import { makeStyles } from "@material-ui/core/styles";

// Set Sidebar width
const drawerWidth = 240;

export default makeStyles((theme) => ({
  // main container
  root: {
    display: "flex",
    backgroundColor: theme.palette.background.gray,
  },
  appBar: {
    boxShadow: theme.palette.boxShadow.main,
    backgroundColor: theme.palette.background.white,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  absOpacity: {
    [theme.breakpoints.down("xs")]: {
      opacity: 0.2,
    },
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  avatarSpacing: {
    padding: "4px 0 4px 4px",
    marginLeft: 10,
  },
  avatarBorder: {
    borderStyle: "solid",
    borderWidth: 3,
    borderColor: theme.palette.primary.main,
  },
  avatar: {
    cursor: "pointer",
  },
  // Right Drawer
  list: {
    width: 500,
  },
  // Sidebar
  menuButton: {
    marginRight: 36,
    color: theme.palette.text.secondary,
    [theme.breakpoints.down("xs")]: {},
  },
  itemButtons: {},
  listItemIcons: {
    paddingLeft: 7,
  },
  btnActive: {
    color: theme.palette.primary.main,
    "& div": {
      color: theme.palette.primary.main,
    },
  },
  btnDisable: {
    color: theme.palette.primary.light,
    "& div": {
      color: theme.palette.primary.light,
    },
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  closedMobile: {
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      zIndex: 999,
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(9) + 1,
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: "40px 70px 20px 70px",
    [theme.breakpoints.down("sm")]: {
      padding: "40px 30px 20px 30px",
    },
    // padding: theme.spacing(3),
  },
  title: {
    flexGrow: 1,
  },
  logoBox: {
    flexGrow: 1,
  },
  logo: {
    maxHeight: 45,
  },
}));
